export const map = (mapSelector) => {
  let currentView = 'clusters';
  let map = null;
  let markers = new Map();
  let activeMarker = null;
  let activeInfoWindow = null;
  let organizationItems = new Map();
  let overlay = null;
  let markerClusterer = null;

  const initMap = () => {
    const mapElement = document.getElementById('map');
    if (!mapElement) {
      return; // Silently return if map element doesn't exist
    }

    const Styled = [
      {
        "featureType": "all",
        "elementType": "all",
        "stylers": [
          {
            "color": "#0b34c6"
          },
          {
            "saturation": "0"
          },
          {
            "lightness": "-50"
          },
          {
            "gamma": "1.00"
          }
        ]
      },
      {
        "featureType": "all",
        "elementType": "geometry",
        "stylers": [
          {
            "weight": "0.75"
          },
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "all",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "weight": "1.00"
          }
        ]
      },
      {
        "featureType": "all",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "all",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          },
          {
            "weight": "0.01"
          },
          {
            "gamma": "0.00"
          },
          {
            "saturation": "-36"
          },
          {
            "lightness": "-100"
          }
        ]
      },
      {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          },
          {
            "color": "#ffffff"
          },
          {
            "weight": "0.01"
          },
          {
            "saturation": "-1"
          },
          {
            "lightness": "-32"
          }
        ]
      },
      {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "gamma": 0.01
          },
          {
            "lightness": 20
          },
          {
            "visibility": "off"
          },
          {
            "color": "#e1e1e1"
          },
          {
            "weight": "0.01"
          }
        ]
      },
      {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "saturation": -31
          },
          {
            "lightness": -33
          },
          {
            "weight": "0.01"
          },
          {
            "gamma": 0.8
          },
          {
            "visibility": "off"
          },
          {
            "hue": "#ff0000"
          }
        ]
      },
      {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "simplified"
          },
          {
            "saturation": "-22"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
          {
            "color": "#0099ff"
          },
          {
            "saturation": "0"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "weight": "0.52"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "simplified"
          },
          {
            "lightness": "20"
          },
          {
            "gamma": "1.00"
          },
          {
            "weight": "1"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "simplified"
          },
          {
            "weight": "0.01"
          },
          {
            "gamma": "1"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "visibility": "simplified"
          },
          {
            "weight": "0.01"
          },
          {
            "gamma": "1"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          },
          {
            "saturation": "1"
          },
          {
            "lightness": "0"
          },
          {
            "gamma": "1.00"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "weight": "0.01"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
          {
            "saturation": "0"
          },
          {
            "gamma": "1"
          },
          {
            "weight": "1.00"
          },
          {
            "hue": "#0038ff"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
          {
            "lightness": 30
          },
          {
            "saturation": 30
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "saturation": 20
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "lightness": 20
          },
          {
            "saturation": -20
          }
        ]
      },
      {
        "featureType": "poi.place_of_worship",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "lightness": 10
          },
          {
            "saturation": -30
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "saturation": 25
          },
          {
            "lightness": 25
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
          {
            "lightness": -20
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "lightness": "0"
          },
          {
            "saturation": "0"
          },
          {
            "color": "#0099ff"
          },
          {
            "gamma": "1"
          }
        ]
      }
    ];

    // Add custom pin styles
    const style = document.createElement('style');
    style.textContent = `
      .custom-pin {
        width: 20px;
        height: 20px;
        background-color: #FFFFFF;
        border-radius: 50%;
        position: relative;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        box-shadow: 0 2px 4px rgba(0,0,0,0.2);
      }
      .custom-pin:hover {
        transform: scale(1.3);
        background-color: #FFC800;
      }
    `;
    document.head.appendChild(style);

    // Get overlay element
    overlay = document.querySelector('.organizations-overlay');
    if (!overlay) {
      console.error('Organizations overlay element not found');
      return;
    }

    // Center on Europe (approximately)
    const myLatLng = { lat: 50.0, lng: 15.0 };

    const options = {
      zoom: currentView === 'clusters' ? 2.5 : 4.4,
      center: myLatLng,
      disableDefaultUI: true,
      scrollwheel: false,
      navigationControl: false,
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
      scaleControl: true,
      scrollwheel: false,
      fontSize: "8px",
      label: {
        fontSize: "8px",
      },
      mapTypeId: "Styled",
    };

    map = new google.maps.Map(mapElement, options);

    const styledMapType = new google.maps.StyledMapType(Styled, {
      name: "Styled",
    });
    map.mapTypes.set("Styled", styledMapType);

    // Add click event to map to close overlay when clicking outside
    map.addListener('click', () => {
      if (overlay.classList.contains('organizations-overlay--visible')) {
        toggleOverlay();
      }
    });

    // Initialize the map with data
    fetchAirtableData();

    // Add toggle button event listeners
    const toggleButtons = document.querySelectorAll('.c-map-toggle__button');
    toggleButtons.forEach(button => {
      button.addEventListener('click', () => {
        const view = button.dataset.view;
        if (view !== currentView) {
          // Update active button
          toggleButtons.forEach(btn => btn.classList.remove('c-map-toggle__button--active'));
          button.classList.add('c-map-toggle__button--active');

          // Update header title
          const headerTitle = document.querySelector('.organizations-overlay__header h2');
          headerTitle.textContent = view === 'clusters' ? 'Clusters' : 'Focal Points';

          // Clear existing markers and content
          clearMap();
          
          // Update current view and fetch new data
          currentView = view;

          // Update zoom level based on view
          const newZoom = view === 'clusters' ? 2.5 : 4.4;
          map.setZoom(newZoom);
          
          fetchAirtableData();
        }
      });
    });

    // Add event listeners for overlay
    const closeButton = document.querySelector('.organizations-overlay__close');
    if (closeButton) {
      closeButton.addEventListener('click', toggleOverlay);
    }
  };

  const clearMap = () => {
    // Clear marker clusterer
    if (markerClusterer) {
      markerClusterer.clearMarkers();
      markerClusterer = null;
    }

    // Clear markers
    markers.forEach(marker => marker.setMap(null));
    markers.clear();
    
    // Clear organization items
    organizationItems.clear();
    
    // Clear list content
    const organizationsList = document.querySelector('.organizations-list');
    organizationsList.innerHTML = '';
    
    // Reset active references
    activeMarker = null;
    if (activeInfoWindow) {
      activeInfoWindow.close();
      activeInfoWindow = null;
    }
  };

  // Toggle overlay visibility
  const toggleOverlay = () => {
    if (overlay) {
      overlay.classList.toggle('organizations-overlay--visible');
    }
  };

  // Function to fetch data from Airtable
  const fetchAirtableData = async () => {
    try {
      const AIRTABLE_PERSONAL_ACCESS_TOKEN = window.AIRTABLE_CONFIG.personal_access_token;
      const AIRTABLE_BASE_ID = window.AIRTABLE_CONFIG.base_id;
      const AIRTABLE_TABLE_NAME = currentView === 'clusters' ? 'Clusters' : window.AIRTABLE_CONFIG.table_name;
      
      let allRecords = [];
      let offset = null;
      
      do {
        const url = new URL(`https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_TABLE_NAME}`);
        if (offset) {
          url.searchParams.append('offset', offset);
        }
        
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${AIRTABLE_PERSONAL_ACCESS_TOKEN}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        allRecords = [...allRecords, ...data.records];
        offset = data.offset;
        
      } while (offset);

      // Sort records alphabetically by name
      const sortedRecords = [...allRecords].sort((a, b) => {
        const nameA = a.fields['Name'] || '';
        const nameB = b.fields['Name'] || '';
        return nameA.localeCompare(nameB);
      });
      
      // Process records and populate overlay
      const organizationsList = document.querySelector('.organizations-list');
      organizationsList.innerHTML = ''; // Clear existing content

      // Group records by country
      const recordsByCountry = sortedRecords.reduce((acc, record) => {
        const country = currentView === 'clusters'
          ? record.fields['Country Lookup'] || 'Other'
          : record.fields['Country'] || 'Other';
        if (!acc[country]) {
          acc[country] = [];
        }
        acc[country].push(record);
        return acc;
      }, {});

      // Sort countries alphabetically
      const sortedCountries = Object.keys(recordsByCountry).sort();

      // Create HTML for each country group
      for (const country of sortedCountries) {
        const countryRecords = recordsByCountry[country];
        
        // Create country header
        const countryHeader = document.createElement('div');
        countryHeader.className = 'organization-item__country-header';
        countryHeader.innerHTML = `<h2 class="organization-item__country-title sans-larger">${country}</h2>`;
        organizationsList.appendChild(countryHeader);
      
        for (const record of countryRecords) {
          try {
            const latitude = record.fields['Latitude'];
            const longitude = record.fields['Longitude'];
            const address = record.fields['Address'];

            if (!latitude || !longitude) {
              console.warn('No coordinates found for record:', record);
              continue;
            }

            const location = {
              lat: parseFloat(latitude),
              lng: parseFloat(longitude),
              name: record.fields['Name'],
              website: record.fields['Website'],
              description: record.fields['Description'],
              person: record.fields['Person'],
              email: record.fields['Email'],
              address: address,
              recordId: record.id
            };

            // Add cluster-specific fields if this is the clusters view
            if (currentView === 'clusters') {
              location.fullMembers = record.fields['Cluster Full Members Lookup'] || [];
              location.associateMembers = record.fields['Associate Members Lookup'] || [];
              location.presidentPerson = record.fields['Cluster Presidency Person Lookup'] || [];
              location.presidentEmail = record.fields['Cluster Presidency Email Lookup'] || [];
              location.presidentBranch = record.fields['Cluster Presidency Branch Lookup'] || [];
              location.contactPerson = record.fields["Cluster Contact Person Lookup"] || [];
              location.contactEmail = record.fields['Cluster Contact Email Lookup'] || [];
              location.facebook = record.fields['Facebook'] || '';
              location.instagram = record.fields['Instagram'] || '';
              location.linkedin = record.fields['LinkedIn'] || '';
            }
            
            const marker = addMarker(location);
            markers.set(record.id, marker);

            // Add to organizations list
            const organizationItem = document.createElement('div');
            organizationItem.className = 'organization-item';
            organizationItem.dataset.recordId = record.id;

            // Build the organization item HTML based on whether it's clusters or focal points
            let organizationItemHTML = `
              <div class="organization-item__header">
                <div class="organization-item__name">${location.name}</div>
                <div class="organization-item__toggle">
                  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              <div class="organization-item__content">
                <div class="organization-item__details">
            `;

            if (currentView === 'clusters') {
              // Add cluster-specific fields
              if (
                location.presidentPerson &&
                location.presidentPerson.length > 0 &&
                location.presidentEmail &&
                location.presidentEmail.length > 0
              ) {
                organizationItemHTML += `
                  <div class="organization-item__section">
                    <h3 class="organization-item__section-title">Cluster President${
                      location.presidentPerson.length > 1 ? "s" : ""
                    }</h3>
                    <ul class="organization-item__members">
                      ${location.presidentPerson
                        .map(
                          (person, index) => `
                        <li>
                          <div class="organization-item__person">${person} ${
                            location.presidentBranch[index] ? `(${location.presidentBranch[index]})` : ""
                          }</div>
                          <div class="organization-item__email"><a href="mailto:${location.presidentEmail[index]}" target="_blank">${location.presidentEmail[index]}</a></div>
                        </li>
                      `
                        )
                        .join("")}
                    </ul>
                  </div>
                `;
              }

              if (location.fullMembers && location.fullMembers.length > 0) {
                organizationItemHTML += `
                  <div class="organization-item__section">
                    <h3 class="organization-item__section-title">Full Members</h3>
                    <ul class="organization-item__members">
                      ${location.fullMembers.map(member => `<li>${member}</li>`).join('')}
                    </ul>
                  </div>
                `;
              }

              if (location.associateMembers && location.associateMembers.length > 0) {
                organizationItemHTML += `
                  <div class="organization-item__section">
                    <h3 class="organization-item__section-title">Associate Members</h3>
                    <ul class="organization-item__members">
                      ${location.associateMembers.map(member => `<li>${member}</li>`).join('')}
                    </ul>
                  </div>
                `;
              }

              // Add social media links
              if (location.website || location.facebook || location.instagram || location.linkedin) {
                organizationItemHTML += `
                  <div class="organization-item__section">
                    <h3 class="organization-item__section-title">Links</h3>
                    <ul class="organization-item__members-links">
                      ${location.website ? `<li><a href="${location.website}" target="_blank">Website</a></li>` : ''}
                      ${location.facebook ? `<li><a href="${location.facebook}" target="_blank">Facebook</a></li>` : ''}
                      ${location.instagram ? `<li><a href="${location.instagram}" target="_blank">Instagram</a></li>` : ''}
                      ${location.linkedin ? `<li><a href="${location.linkedin}" target="_blank">LinkedIn</a></li>` : ''}
                    </ul>
                  </div>
                `;
              }
            } else {
              // Add focal points specific fields
              organizationItemHTML += `
                ${
                  location.person
                    ? `<div class="organization-item__section">
                         <span class="organization-item__section-title t-faded">Focal Point</span>
                         ${
                           location.person
                             ? `<div class="organization-item__person">${location.person}</div>`
                             : ""
                         }
                         ${
                           location.email
                             ? `<div class="organization-item__email"><a href="mailto:${location.email}" class="t-link" target="_blank">${location.email}</a></div>`
                             : ""
                         }
                       </div>`
                    : ""
                }
                ${
                  location.description
                    ? `<div class="organization-item__description">${location.description}</div>`
                    : ""
                }
                ${
                  location.website
                    ? `<div class="organization-item__contact">
                         ${
                           location.website
                             ? `<div class="organization-item__website"><a href="${location.website}" class="t-link" target="_blank">Visit Website</a></div>`
                             : ""
                         }
                       </div>`
                    : ""
                }
              `;
            }

            organizationItemHTML += `
                </div>
              </div>
            `;

            organizationItem.innerHTML = organizationItemHTML;

            // Add mouseover handler to organization item
            organizationItem.addEventListener('mouseover', () => {
              // Only show marker if no item is selected
              if (!document.querySelector('.organization-item--selected')) {
                // Center map on marker
                const marker = markers.get(record.id);
                if (marker) {
                  map.panTo(marker.getPosition());
                  
                  // Close any previously open info window
                  if (activeInfoWindow) {
                    activeInfoWindow.close();
                  }
                  
                  // Create and open new info window
                  const infowindow = new google.maps.InfoWindow({
                    content: marker.content,
                    maxWidth: 300
                  });
                  
                  infowindow.open(map, marker);
                  activeInfoWindow = infowindow;
                  activeMarker = marker;
                  
                  // Set marker as active
                  marker.setIcon({
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: "#FFC800",
                    fillOpacity: 1,
                    strokeColor: "#FFC800",
                    strokeWeight: 6,
                    anchor: new google.maps.Point(0, 0),
                  });
                }
              }
            });

            // Add mouseout handler to organization item
            organizationItem.addEventListener('mouseout', () => {
              // Only reset if it's not the active/selected item
              if (!organizationItem.classList.contains('organization-item--selected')) {
                // Close info window
                if (activeInfoWindow) {
                  activeInfoWindow.close();
                  activeInfoWindow = null;
                }
                
                // Reset marker appearance
                const marker = markers.get(record.id);
                if (marker && marker === activeMarker) {
                  marker.setIcon({
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 8,
                    fillColor: "#FFFFFF",
                    fillOpacity: 0.01,
                    strokeColor: "#FFFFFF",
                    strokeWeight: 6,
                    anchor: new google.maps.Point(0, 0),
                  });
                  activeMarker = null;
                }
              }
            });

            organizationsList.appendChild(organizationItem);

            // Store reference to organization item
            organizationItems.set(record.id, organizationItem);

            // Add click handler to organization item
            organizationItem.addEventListener('click', (e) => {
              // Don't toggle if clicking on a link
              if (e.target.tagName === 'A') return;

              // Toggle expanded state
              const isExpanded = organizationItem.classList.contains('organization-item--expanded');
              const content = organizationItem.querySelector('.organization-item__content');
              const toggle = organizationItem.querySelector('.organization-item__toggle');

              // Remove expanded state from all items
              document.querySelectorAll('.organization-item').forEach(item => {
                item.classList.remove('organization-item--expanded', 'organization-item--selected');
                const content = item.querySelector('.organization-item__content');
                const toggle = item.querySelector('.organization-item__toggle');
                if (content) content.classList.remove('organization-item__content--expanded');
                if (toggle) toggle.classList.remove('organization-item__toggle--expanded');

                // Reset corresponding marker state
                const marker = markers.get(item.dataset.recordId);
                if (marker) {
                  marker.setIcon({
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 8,
                    fillColor: "#ffffff",
                    fillOpacity: 0.01,
                    strokeColor: "#ffffff",
                    strokeWeight: 6,
                    anchor: new google.maps.Point(0, 0),
                  });
                }
              });

              // Toggle current item
              if (!isExpanded) {
                organizationItem.classList.add('organization-item--expanded', 'organization-item--selected');
                content.classList.add('organization-item__content--expanded');
                toggle.classList.add('organization-item__toggle--expanded');

                // Center map on marker
                const marker = markers.get(record.id);
                if (marker) {
                  map.panTo(marker.getPosition());
                  
                  // Close any previously open info window
                  if (activeInfoWindow) {
                    activeInfoWindow.close();
                  }
                  
                  // Create and open new info window
                  const infowindow = new google.maps.InfoWindow({
                    content: marker.content,
                    maxWidth: 300
                  });
                  
                  infowindow.open(map, marker);
                  activeInfoWindow = infowindow;
                  activeMarker = marker;
                  
                  // Set marker as active
                  marker.setIcon({
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: "#FFC800",
                    fillOpacity: 1,
                    strokeColor: "#FFC800",
                    strokeWeight: 6,
                    anchor: new google.maps.Point(0, 0),
                  });
                }
              } else {
                // If closing the item, reset the marker state
                const marker = markers.get(record.id);
                if (marker) {
                  marker.setIcon({
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 8,
                    fillColor: "#FFFFFF",
                    fillOpacity: 0.01,
                    strokeColor: "#FFFFFF",
                    strokeWeight: 6,
                    anchor: new google.maps.Point(0, 0),
                  });
                }
                // Close info window
                if (activeInfoWindow) {
                  activeInfoWindow.close();
                  activeInfoWindow = null;
                }
                activeMarker = null;
              }
            });
          } catch (error) {
            console.error('Error processing record:', record, error);
          }
        }
      }

      // After processing all records and creating markers
      const markerArray = Array.from(markers.values());
      
      // Create marker clusterer
      markerClusterer = new MarkerClusterer({
        map,
        markers: markerArray,
        gridSize: 50,
        minimumClusterSize: 2,
        renderer: {
          render: ({ count, position }) => {
            const svg = `
              <svg width="35" height="35" viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg">
                <circle cx="17.5" cy="17.5" r="17.5" fill="#ffffff" />
                <text x="17.5" y="22" text-anchor="middle" font-family="Arial, sans-serif" font-size="14" font-weight="bold" fill="#000000">${count}</text>
              </svg>
            `;
            
            const marker = new google.maps.Marker({
              position,
              icon: {
                url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
                scaledSize: new google.maps.Size(35, 35),
                anchor: new google.maps.Point(17.5, 17.5)
              },
              zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
            });
            return marker;
          }
        }
      });

    } catch (error) {
      console.error('Error fetching Airtable data:', error);
    }
  };

  // Function to create custom pin element
  const createCustomPin = () => {
    const pin = document.createElement('div');
    pin.className = 'custom-pin';
    return pin;
  };

  const addMarker = (location) => {
    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(location.lat, location.lng),
      map: map,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 8,
        fillColor: "#FFFFFF",
        fillOpacity: 0.01,
        strokeColor: "#FFFFFF",
        strokeWeight: 6,
        anchor: new google.maps.Point(0, 0),
      },
    });

    // Store the record ID on the marker
    marker.recordId = location.recordId;

    // Build content string
    let contentString = '<div class="map-info-window">';
    
    if (location.name) {
      contentString += `<h3 class="map-info-window__title"><strong>${location.name}</strong></h3>`;
    }

    contentString += '</div>';

    // Store content string on marker
    marker.content = contentString;

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
      maxWidth: 300
    });

    const setActiveState = (isActive) => {
      marker.setIcon({
        path: google.maps.SymbolPath.CIRCLE,
        scale: isActive ? 10 : 8,
        fillColor: isActive ? "#FFC800" : "#FFC800",
        fillOpacity: isActive ? 1 : 0.01,
        strokeColor: isActive ? "#FFC800" : "#FFFFFF",
        strokeWeight: 6,
        anchor: new google.maps.Point(0, 0),
      });
    };

    google.maps.event.addListener(marker, "click", () => {
      // Reset all markers' states first
      markers.forEach((existingMarker) => {
        existingMarker.setIcon({
          path: google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: "#FFFFFF",
          fillOpacity: 0.01,
          strokeColor: "#FFFFFF",
          strokeWeight: 6,
          anchor: new google.maps.Point(0, 0),
        });
      });

      // Close any previously open info window
      if (activeInfoWindow) {
        activeInfoWindow.close();
      }

      // Set active state
      setActiveState(true);

      // Update active references
      activeMarker = marker;

      // Show overlay and highlight corresponding organization
      if (!overlay.classList.contains('organizations-overlay--visible')) {
        toggleOverlay();
      }

      // Find and select the corresponding organization item
      const organizationItem = organizationItems.get(marker.recordId);
      if (organizationItem) {
        // Remove selected state from all items
        document.querySelectorAll('.organization-item').forEach(item => {
          item.classList.remove('organization-item--expanded', 'organization-item--selected');
          const content = item.querySelector('.organization-item__content');
          const toggle = item.querySelector('.organization-item__toggle');
          if (content) content.classList.remove('organization-item__content--expanded');
          if (toggle) toggle.classList.remove('organization-item__toggle--expanded');
        });

        // Add selected state to the clicked organization
        organizationItem.classList.add('organization-item--expanded', 'organization-item--selected');
        const content = organizationItem.querySelector('.organization-item__content');
        const toggle = organizationItem.querySelector('.organization-item__toggle');
        if (content) content.classList.add('organization-item__content--expanded');
        if (toggle) toggle.classList.add('organization-item__toggle--expanded');

        // Scroll to the selected organization
        organizationItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    google.maps.event.addListener(marker, "mouseover", () => {
      if (marker !== activeMarker) {
        setActiveState(true);
        
        // Create and open info window on hover
        const infowindow = new google.maps.InfoWindow({
          content: marker.content,
          maxWidth: 300
        });
        
        infowindow.open(map, marker);
        activeInfoWindow = infowindow;
      }
    });

    google.maps.event.addListener(marker, "mouseout", () => {
      if (marker !== activeMarker) {
        setActiveState(false);
        
        // Close info window on mouseout if it's not the active marker
        if (activeInfoWindow && marker !== activeMarker) {
          activeInfoWindow.close();
          activeInfoWindow = null;
        }
      }
    });

    // Add listener for info window close
    google.maps.event.addListener(infowindow, "closeclick", () => {
      setActiveState(false);
      activeMarker = null;
      activeInfoWindow = null;
    });

    // Add listener for when info window is closed by clicking another marker
    google.maps.event.addListener(infowindow, "close", () => {
      if (marker === activeMarker) {
        setActiveState(false);
        activeMarker = null;
        activeInfoWindow = null;
      }
    });

    return marker;
  };

  // Initialize the map
  initMap();
};
